import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";

export default function DueMembers() {
  const [dueMembers, setDueMembers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadDueMembers = async () => {

      /* ================= MEMBERS ================= */
      const membersSnap = await getDocs(collection(db, "members"));
      const members = {};

      membersSnap.forEach(doc => {
        const m = doc.data();
        if (!m.memberId) return;

        members[m.memberId] = {
          name: m.name || "",
          mobile: m.mobile || "",
        };
      });

      /* ================= LEDGER ================= */
      const ledgerSnap = await getDocs(collection(db, "savingLedger"));

      const calc = {};

      ledgerSnap.forEach(doc => {
        const l = doc.data();
        if (!l.memberId) return;

        if (!calc[l.memberId]) {
          calc[l.memberId] = { credit: 0, debit: 0 };
        }

        // 🔥 SUPPORT BOTH FORMATS
        if (l.type === "CREDIT") calc[l.memberId].credit += Number(l.amount || 0);
        if (l.type === "DEBIT") calc[l.memberId].debit += Number(l.amount || 0);

        if (l.deposit) calc[l.memberId].credit += Number(l.deposit || 0);
        if (l.withdrawal) calc[l.memberId].debit += Number(l.withdrawal || 0);
      });

      /* ================= DUE ================= */
      const list = Object.keys(calc)
        .map(memberId => {
          const balance = calc[memberId].credit - calc[memberId].debit;

          return {
            memberId,
            memberName: members[memberId]?.name || "",
            mobile: members[memberId]?.mobile || "",
            dueAmount: Math.abs(balance),
            balance,
          };
        })
        .filter(m => m.balance < 0); // 🔥 NEGATIVE = DUE

      console.log("✅ DUE MEMBERS FINAL", list);
      setDueMembers(list);
    };

    loadDueMembers();
  }, []);

  /* ================= WHATSAPP ================= */
  const sendWhatsApp = (m) => {
    if (!m.mobile) {
      alert("Mobile number not available");
      return;
    }

    const msg = `Dear ${m.memberName},
Your saving account has due amount ₹${m.dueAmount}.
Please clear it at earliest.`;

    window.open(
      `https://wa.me/91${m.mobile}?text=${encodeURIComponent(msg)}`,
      "_blank"
    );
  };

  const viewLedger = (memberId) => {
    navigate(`/saving-ledger?memberId=${memberId}`);
  };

  /* ================= PDF ================= */
  const downloadPDF = () => {
    const pdf = new jsPDF();
    pdf.text("Due Members Report", 14, 10);

    pdf.autoTable({
      startY: 20,
      head: [["Sr", "Name", "Member ID", "Mobile", "Due Amount"]],
      body: dueMembers.map((m, i) => [
        i + 1,
        m.memberName,
        m.memberId,
        m.mobile,
        `₹ ${m.dueAmount}`,
      ]),
    });

    pdf.save("Due_Members_Report.pdf");
  };

  /* ================= EXCEL ================= */
  const downloadExcel = () => {
    const data = dueMembers.map((m, i) => ({
      Sr: i + 1,
      Name: m.memberName,
      MemberID: m.memberId,
      Mobile: m.mobile,
      DueAmount: m.dueAmount,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Due Members");
    XLSX.writeFile(wb, "Due_Members_Report.xlsx");
  };

  return (
    <div className="container-fluid">
      <h4 className="mb-3">Due Members</h4>

      <div className="mb-3 d-flex gap-2">
        <button className="btn btn-danger btn-sm" onClick={downloadPDF}>
          PDF
        </button>
        <button className="btn btn-success btn-sm" onClick={downloadExcel}>
          Excel
        </button>
      </div>

      <table className="table table-bordered table-sm text-center">
        <thead className="table-dark">
          <tr>
            <th>Sr</th>
            <th>Name</th>
            <th>Member ID</th>
            <th>Mobile</th>
            <th>Due Amount</th>
            <th>WhatsApp</th>
            <th>Ledger</th>
          </tr>
        </thead>

        <tbody>
          {dueMembers.length === 0 && (
            <tr>
              <td colSpan="7" className="text-success">
                🎉 No Due Members
              </td>
            </tr>
          )}

          {dueMembers.map((m, i) => (
            <tr key={m.memberId}>
              <td>{i + 1}</td>
              <td>{m.memberName}</td>
              <td>{m.memberId}</td>
              <td>{m.mobile}</td>
              <td className="fw-bold text-danger">₹ {m.dueAmount}</td>
              <td>
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => sendWhatsApp(m)}
                >
                  WhatsApp
                </button>
              </td>
              <td>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => viewLedger(m.memberId)}
                >
                  View Ledger
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}